/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

export const FONT_COLOR = 'fontColor';
export const THEME_COLOR_ATTRIBUTE = 'theme-palette';
export const DEFAULT_COLORS = [
	"#1abc9c",
	"#2ecc71",
	"#3498db",
	"#9b59b6",
	"#34495e",
	"#16a085",
	"#27ae60",
	"#2980b9",
	"#8e44ad",
	"#2c3e50",
	"#f1c40f",
	"#e67e22",
	"#e74c3c",
	"#bdc3c7",
	"#95a5a6",
	"#f39c12",
	"#000000",
	"#ffffff"
];

